import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const DespreNoi = lazy(() => import('../pages/despre-noi/page'));
const Galerie = lazy(() => import('../pages/galerie/page'));
const Stiri = lazy(() => import('../pages/stiri/page'));
const Articol = lazy(() => import('../pages/stiri/articol/page'));
const Utile = lazy(() => import('../pages/utile/page'));
const Programe = lazy(() => import('../pages/programe/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const Calcan = lazy(() => import('../pages/calcan/page'));
const PescuitulRomanesc = lazy(() => import('../pages/pescuitul-romanesc/page'));
const GastronomiePescareasca = lazy(() => import('../pages/gastronomie-pescareasca/page'));
const PoliticaConfidentialitate = lazy(() => import('../pages/politica-confidentialitate/page'));
const PoliticaCookie = lazy(() => import('../pages/politica-cookie/page'));
const TermeniSiConditii = lazy(() => import('../pages/termeni-si-conditii/page'));
const PescariiProfesionisti = lazy(() => import('../pages/pescarii-profesionisti/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/despre-noi',
    element: <DespreNoi />,
  },
  {
    path: '/galerie',
    element: <Galerie />,
  },
  {
    path: '/stiri',
    element: <Stiri />,
  },
  {
    path: '/stiri/:id',
    element: <Articol />,
  },
  {
    path: '/utile',
    element: <Utile />,
  },
  {
    path: '/pescuitul-romanesc/calcan',
    element: <Calcan />,
  },
  {
    path: '/programe',
    element: <Programe />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/pescuitul-romanesc',
    element: <PescuitulRomanesc />,
  },
  {
    path: '/pescarii-profesionisti',
    element: <PescariiProfesionisti />,
  },
  {
    path: '/gastronomie-pescareasca',
    element: <GastronomiePescareasca />,
  },
  {
    path: '/politica-confidentialitate',
    element: <PoliticaConfidentialitate />,
  },
  {
    path: '/politica-cookie',
    element: <PoliticaCookie />,
  },
  {
    path: '/termeni-si-conditii',
    element: <TermeniSiConditii />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;